export default {
  STATUSVISIT: {
    UNASSIGNED: "CREADA",
    ASSIGNED: "ASIGNADA",
    RESCHEDULED: "REPROGRAMADA",
    CANCELLED: "CANCELADA"
  },
  SIDEBAR: {
    HEADER: {
      designer: "Diseñador",
      forms: "Formularios",
      users: "Usuarios",
      controlPanel: "Panel de Control",
      visits: "Visitas"
    },
    "Users-list": "Lista de usuarios",
    "assign-forms": "Asignación masiva",
    "Form-list": "Lista de formularios",
    Multiforms: "Multiformularios",
    dashboard: "Dashboard",
    design: "Diseñador",
    migrate: "Asistente de migracion",
    transfer: "Transferencia de formularios",
    companies: "Compañias",
    groups: "Grupos",
    dataOrigin: "Origen de Datos",
    conections: "Conexiones Externas",
    accessTokens: "Tokens de accesso",
    statistics: "Estadísticas",
    Keychains: "Claves para api's map",
    clients: "Clientes",
    "module-visits": "Visitas",
    "assign-visits": "Asignar visitas",
    "assign-visit": "Asignar visita",
    "schedule-visit": "Agendar visita"
  },
  LOCALES: {
    french: "Francés",
    english: "Inglés",
    spanish: "Español",
    portugués: "Portugués"
  },
  ROLES: {
    ADMIN: "Administrador",
    EXPRESS: "Usuario en campo",
    GOTU: "Super Administrador"
  },
  PROFILE: {
    profile: "Perfil",
    logout: "Salir"
  },
  cellPhone: "Número celular",
  Dashboard: "Dashboard",
  eCommerce: "eCommerce",
  Apps: "Apps",
  Todo: "Todo",
  Chat: "Chat",
  Email: "Email",
  Calendar: "Calendario",
  FullCalendar: "Full Calendar",
  SimpleCalendar: "Calendar simple",
  Shop: "Compras",
  ItemDetails: "Detalles de productos",
  Cart: "Carrito",
  WishList: "Lista de deseos",
  Checkout: "Pagos",
  UI: "UI",
  DataList: "Data List",
  ListView: "List View",
  ThumbView: "Thumb View",
  Grid: "Grid",
  Vuexy: "Vuexy",
  Vuesax: "Vuesax",
  Tailwind: "Tailwind",
  Colors: "Colors",
  Card: "Card",
  Basic: "Basic",
  Statistics: "Estadisticas",
  Analytics: "Analitica",
  CardActions: "Card Actions",
  CardColors: "Card Colors",
  Table: "Table",
  agGridTable: "agGrid Table",
  Components: "Componentes",
  Alert: "Alertas",
  Avatar: "Avatar",
  Badge: "Badge",
  Breadcrumb: "Breadcrumb",
  Button: "Botones",
  ButtonGroup: "Grupos de Botones",
  Chip: "Chip",
  Collapse: "Collapse",
  Dialogs: "Dialogos",
  Divider: "Divider",
  DropDown: "DropDown",
  List: "Listas",
  Loading: "Loading",
  Navbar: "Navbar",
  Notifications: "Notificaciones",
  Pagination: "Paginacion",
  Popup: "Popup",
  Progress: "Progress",
  Sidebar: "Sidebar",
  Slider: "Slider",
  Tabs: "Tabs",
  Tooltip: "Tooltip",
  Upload: "Upload",
  FormsAndTable: "Forms & Table",
  FormElements: "Form Elements",
  Select: "Select",
  Switch: "Switch",
  Checkbox: "Checkbox",
  Radio: "Radio",
  Input: "Input",
  NumberInput: "Number Input",
  Textarea: "Textarea",
  FormLayouts: "Form Layouts",
  FormWizard: "Form Wizard",
  FormValidation: "Form Validation",
  FormInputGroup: "Form Input Group",
  Pages: "Paginas",
  Authentication: "Authentication",
  Login: "Login",
  Register: "Register",
  ForgotPassword: "Forgot Password",
  ResetPassword: "Reset Password",
  LockScreen: "Lock Screen",
  Miscellaneous: "Miscellaneous",
  ComingSoon: "Coming Soon",
  Error: "Error",
  404: "404",
  500: "500",
  NotAuthorized: "Not Authorized",
  Maintenance: "Maintenance",
  Profile: "Perfil",
  User: "Usuarios",
  View: "View",
  Edit: "Edit",
  UserSettings: "User Settings",
  Invoice: "Facturas",
  FAQ: "FAQ",
  Search: "Busqueda",
  KnowledgeBase: "Knowledge Base",
  ChartsAndMaps: "Charts & Maps",
  Charts: "Charts",
  ApexCharts: "Apex Charts",
  chartjs: "chartjs",
  echarts: "echarts",
  chartist: "chartist",
  GoogleMap: "Google Map",
  Extensions: "Extensiones",
  QuillEditor: "Quill Editor",
  DragAndDrop: "Drag & Drop",
  Datepicker: "Datepicker",
  DatetimePicker: "Datetime Picker",
  AccessControl: "Control de acceso",
  I18n: "I18n",
  Carousel: "Carrusel",
  Clipboard: "Clipboard",
  ContextMenu: "Context Menu",
  StarRatings: "Star Ratings",
  Autocomplete: "Autocomplete",
  Tree: "Tree",
  // "Import/Export": 'Import/Export',
  Import: "Import",
  Export: "Export",
  ExportSelected: "Export Selected",
  Others: "Others",
  MenuLevels: "Menu Levels",
  MenuLevel2p1: "Menu Level 2.1",
  MenuLevel2p2: "Menu Level 2.2",
  MenuLevel3p1: "Menu Level 3.1",
  MenuLevel3p2: "Menu Level 3.2",
  DisabledMenu: "Disabled Menu",
  Support: "Suporte",
  Documentation: "Documentacion",
  RaiseSupport: "Raise Support",
  demoTitle: "Card Title",
  demoText:
    "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops."
};
